import PropTypes from "prop-types";

import { useGetUser, USER_INCLUDES } from "@/entities/user";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import UserEdit from "./UserEdit.component";

const UserEditWrapper = ({ userId }) => {
  const includes = [USER_INCLUDES.ORGANIZATION, USER_INCLUDES.ROLES];

  const { user, isLoading } = useGetUser(userId, {
    params: { include: includes.join(",") },
  });

  return (
    <FetchItemWrapper
      item={user}
      loading={isLoading}
      renderContent={(user) => <UserEdit model={user} />}
    />
  );
};

UserEditWrapper.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default UserEditWrapper;
